import * as React from "react";
import {Party, PaymentCard,} from "@ferry/journey-services";
import {getAmountWithDecimalDigits} from "../../CommonFunctions";
import {PanelDashed} from "../PanelDashed";

interface IProps {
    location?: any,
    amount: number | null,
    party: Party,
    handleExistingCardPayment: (event: any, cardId?: number) => void,
    newCardUrl: string,
    mainCard?: PaymentCard
}

export class CardPaymentPanel extends React.Component<IProps> {

    public render() {
        return (
            <React.Fragment>
                {this.renderPaymentContent()}
            </React.Fragment>
        );
    }

    private renderCardsButtons(card?: PaymentCard) {
        const amountToPay = this.props.amount;

        return (
            <button className="btn btn-primary btn-make-payment m-auto margin-top-17 justify-content-center"
                onClick={(event: any) => this.props.handleExistingCardPayment(event, card?.id)}
                id={"card-" + card?.cardNumberObfuscated}
                aria-label={`${getAmountWithDecimalDigits(amountToPay)} to pay`}
            >
                {`Pay ${getAmountWithDecimalDigits(amountToPay)}`}
                <span className="payment-lock-image"></span>
            </button>
        )
    };

    private renderPaymentContent() {
        return (
            <PanelDashed className="shadow bg-white text-center pay-by-card-panel">
                <div
                    className="panel-dashed-contents card-information">{this.renderCardInformation(this.props.mainCard)}</div>
                {this.props.mainCard &&
                    <>
                        <div className="pb-2 or-divider"> OR</div>
                        <div className="simple-link no-outline use-different-cart-link"
                             id="changeCard"
                             role="link"
                             aria-label="Use a different card to pay"
                             onClick={this.navigateToNewPaymentCardPage}
                             tabIndex={0}
                        >
                            Use a different card
                        </div>
                    </>
                }
                <div className="panel-dashed-contents card-buttons">{this.renderCardsButtons(this.props.mainCard)}</div>
            </PanelDashed>
        );
    }

    private readonly navigateToNewPaymentCardPage = (): void => {
        window.location.href = this.props.newCardUrl;
    };

    private renderCardInformation(card?: PaymentCard) {
        if (card) {
            return (
                <div className="d-flex justify-content-center mt-3">
                    <div className="card-details-wrapper">
                        <span className="pr-2">{this.renderCardImage(card)}</span>&nbsp;
                        <span>{this.renderCardTypeName(card)}</span>&nbsp;
                        <span>ending in <b>{card.cardNumberObfuscated.split('******')[1]}</b></span>
                    </div>
                </div>
            );
        } else {
            return null
        }
    };

    private readonly renderCardImage = (card: PaymentCard) => {
        if (card.cardType.includes("VISA")) {
            return <img className="payment-icon" alt="Visa icon" src="/img/visa-icon.svg"/>;
        }
        if (card.cardType.includes("MASTERCARD")) {
            return <img className="payment-icon" alt="Mastercard icon" src="/img/mastercard-icon.svg"/>;
        }
        return null;
    };

    private readonly renderCardTypeName = (card: PaymentCard): string => {
        if (card.cardType.includes("VISA")) {
            return "Visa";
        }
        if (card.cardType.includes("MASTERCARD")) {
            return "Mastercard";
        }
        return "";
    };
}
